import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App'
import { ColorModeProvider } from './contexts/ColorModeContext'
import { NavDensityProvider } from './contexts/NavDensityContext'
import { installIosKeyboardFixes } from './core/iosKeyboard'
import { unregisterServiceWorkerInBrowserTab } from './core/pwa/unregisterServiceWorkerInBrowserTab'

installIosKeyboardFixes()
const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement!)
import { attachPortalHyperDxClientIp, initPortalHyperDx } from './core/hyperdx/initPortalHyperDx'
import { LicenseInfo } from '@mui/x-license'
import { app } from './config/firebase'

if (process.env.VITE_MUI_X_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(process.env.VITE_MUI_X_LICENSE_KEY)
} else {
  console.warn('MUI X License key not found in environment variables')
}

if (import.meta.env.DEV && import.meta.env.VITE_REACT_SCAN === 'true') {
  void import('react-scan').then(({ scan }) => {
    scan({
      enabled: true,
      log: true,
    })
  })
}

if (initPortalHyperDx()) {
  attachPortalHyperDxClientIp()
}

void unregisterServiceWorkerInBrowserTab()
  .catch(() => undefined)
  .then(() => {
  root.render(
    // <React.StrictMode>
    <ColorModeProvider>
      <NavDensityProvider>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <App />
      </NavDensityProvider>
    </ColorModeProvider>,
    // </React.StrictMode>,
  )
  })
